import React from 'react';
import svg from './heart.svg';
import './Component.css';


const ShowResult = (props) =>{
	if (props.isLoaded === ''){
		return(
			<div className='none'>
				<div className='block'>
					<h3>{props.fname}</h3>
					<div className='container'>
						<img alt='Heart' className="svg" src={svg} />
						<h2 className='centered'>{props.result}</h2>
					</div>
					<h3>{props.sname}</h3>
				</div>
				<p className='result'>{props.message}</p>
			</div>
		);
	}
	else if (props.isLoaded === 'none'){
		return(
			<div>
				<div class="lds-heart"><div></div></div>
				<div className="none">
					<div className='block'>
						<h3>{props.fname}</h3>
						<div className='container'>
							<img alt='Heart' className="svg" src={svg} />
							<h2 className='centered'>{props.result}</h2>
						</div>
						<h3>{props.sname}</h3>
					</div>
					<p className='result'>{props.message}</p>
				</div>
			</div>
		);
	}

	else{
		return(
			<div>
				<div className='block'>
					<h3>{props.fname}</h3>
					<div className='container'>
						<img alt='Heart' className="svg" src={svg} />
						<h2 className='centered'>{props.result}</h2>
					</div>
					<h3>{props.sname}</h3>
				</div>
				<p className='result'>{props.message}</p>
			</div>
		);
	}
}

export default ShowResult;